import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface UpgradeOverlayProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function UpgradeOverlay({
  open,
  onOpenChange,
}: UpgradeOverlayProps) {
  const handleUpgrade = () => {
    // Handle upgrade action
    navigator("/pricing");
  };

  const navigator = useNavigate();

  useEffect(() => {
    // Redirect to pricing page on mount
    navigator("/dashboard/campaigns");
  }, [navigator]);

  const handleBookCall = () => {
    // Handle book a call action
    // https://calendly.com/k-ketselidis/discovery-call?month=2025-06&date=2025-06-26
    window.open(
      "https://calendly.com/k-ketselidis/discovery-call?month=2025-06&date=2025-06-26",
      "_blank"
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center pb-4">
          {/* <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-r from-orange-500 to-red-500">
            <Crown className="h-6 w-6 text-white" />
          </div> */}
          <DialogTitle className="text-xl text-center">
            Upgrade Required
          </DialogTitle>
          <DialogDescription className="text-center">
            Your current plan has reached its{" "}
            <span className="text-primary">7 day limit</span>. Upgrade now to
            continue enjoying all features.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex flex-col gap-2">
            <Button onClick={handleUpgrade} className="w-full">
              Upgrade Plan
            </Button>
            <Button
              variant="outline"
              onClick={handleBookCall}
              className="w-full"
            >
              Book a Call
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
